import { useState } from 'react';

// Polje za lozinku sa "okcem" za prikaz/sakrivanje unetog teksta.
// Prima iste props kao <input>; margine iz style prenosi na omotac da raspored ostane isti.
export function PasswordInput({ style = {}, ...props }) {
  const [visible, setVisible] = useState(false);
  const { margin, marginTop, marginBottom, marginLeft, marginRight, ...inputStyle } = style;

  return (
    <div style={{ position: 'relative', margin, marginTop, marginBottom, marginLeft, marginRight }}>
      <input
        {...props}
        type={visible ? 'text' : 'password'}
        style={{ width: '100%', boxSizing: 'border-box', ...inputStyle, paddingRight: 40 }}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        title={visible ? 'Sakrij lozinku' : 'Prikaži lozinku'}
        aria-label={visible ? 'Sakrij lozinku' : 'Prikaži lozinku'}
        tabIndex={-1}
        style={{
          position: 'absolute', top: 0, right: 0, bottom: 0, width: 38,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'transparent', border: 'none', cursor: 'pointer', color: '#888', padding: 0
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
          {visible && <line x1="3" y1="3" x2="21" y2="21" />}
        </svg>
      </button>
    </div>
  );
}
